import React, { useState, useCallback } from "react";
import { Card, Form, Col, Row } from "react-bootstrap";

import { useLoad, useStore } from "./../hooks";
import Select from "react-select";
import { components } from "react-select";
import MissingContactView from "../../../../shared/MissingContactView";
import ErrorIcon from "../../../../shared/ErrorIcon";
import { ProjectUser, Vendor } from "../../../../models";

import "./../../../../index.css";
import { showSuccessMessage } from "../../../../utils";
import { Modal } from "react-bootstrap";
import jonesLogo from "./../../../../shared/images/JonesLogo.png";
import COIIcon from "./../../../../shared/images/COIIcon.png";
import procoreLogo from "./../../../../shared/images/procoreLogo.svg";
import { Button } from "@procore/core-react";

const CUSTOM_REQUIREMENT_LINK =
  "https://app.smartsheet.com/b/form/7f8c0af2ea4b499886195d65945090db";

interface ICreateCOI {
  showCOIModal: boolean;
  onClose: (v: boolean) => void;
  onSaved: () => void;
  setIsShowModal?: (value: boolean) => void;
  sidePanelVenodrId: string;
  commitmentType: string;
}

function CreateGlobalRequest(props: ICreateCOI) {
  const { onClose, showCOIModal, onSaved, setIsShowModal, sidePanelVenodrId ,commitmentType} =
    props;
  const {
    project,
    errorMessage,
    loading,
    insurance,
    setInsurance,
    onLoadVendorsUsers,
    getVendorsCOItag,
    loadingUsers,
    setLoadingUsers,
    permissions,
    onLoadProject,
    onLoadSidePanelVendor,
    onLoadGlobalProcoreProjectId,
    globalProcoregProjectId,
    onLoadPermissions,
  } = useLoad();
  const [isShowModal, setIsShowModal1] = useState<boolean>(false);

  const [defaultVendor, SetDefaultVendor] = useState<Array<Vendor>>([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const data = await onLoadSidePanelVendor(sidePanelVenodrId, "global", commitmentType);
      if (data) {
        SetDefaultVendor([{ ...data }]);
      }
    };
    fetchData();
  }, [sidePanelVenodrId, onLoadSidePanelVendor, commitmentType]);

  React.useEffect(() => {
    const fetchData = async () => {
      const data = await onLoadGlobalProcoreProjectId();
      if (data) {
        setInsurance({
          ...insurance,
          projectId: data,
        });
      }
    };
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLoadGlobalProcoreProjectId]);

  React.useEffect(() => {
    onLoadPermissions();
  }, [onLoadPermissions]);

  const Menu = (props: any) => {
    var projectcode = "";
    if (project.code == null) {
      projectcode = "N/A";
    } else {
      projectcode = project.code;
    }

    return (
      <components.Menu {...props}>
        {props.children}

        <a
          href={
            CUSTOM_REQUIREMENT_LINK +
            "?Requestor%20Email=" +
            project.logeduser +
            "&Company%20Name=" +
            project.comanyAccName
          }
          rel="noopener noreferrer"
          target="_blank"
          style={styles.addCustomRequiremntLink}
          onClick={(event) => {
            setIsShowModal1(true);
          }}
        >
          +Add Custom Requirements
        </a>
      </components.Menu>
    );
  };

  React.useEffect(() => {
    onLoadProject("global");
  }, [onLoadProject]);

  const { submitting, onStore } = useStore();
  const [isModelOpen, setIsModelOpen] = useState<boolean>(false);

  const handleRequirementChange = useCallback(
    (e: any) => {
      const requirementId = e.id;
      if (requirementId >= 0 && e.tabId) {
        const requirement = project.requirementList?.find(
          (x: any) => x.id === +requirementId && x.tabId === e.tabId
        );
        if (requirement) {
          setInsurance({
            ...insurance,
            requirementId: requirement.id,
            tabId: requirement.tabId,
            vendors: defaultVendor,
          });
        }
      }
    },
    [project, insurance, setInsurance, defaultVendor]
  );

  const checkCOIRoleProjectUsers = useCallback(async () => {
    const vendorIds = defaultVendor?.map((e) => {
      return e.id;
    });

    const data: ProjectUser[] = await onLoadVendorsUsers(
      insurance.companyId.toString(),
      vendorIds
    );
    const vendorUserTag = await getVendorsCOItag(
      insurance.companyId.toString()
    );

    if (data && data.length) {
      insurance.vendors.forEach((vendor) => {
        const vendorUsers = data.filter(
          (x: ProjectUser) => x.vendor?.id === vendor.id
        );
        if (vendorUsers && vendorUsers.length) {
          const coiVendorUser = vendorUsers.filter((x: ProjectUser) =>
            x.notes?.toUpperCase().includes(vendorUserTag.coiTag)
          );
          if (coiVendorUser && coiVendorUser.length) {
            vendor.projectUsers = coiVendorUser;
            const coiContactUser = coiVendorUser[0]; // need to sort by name
            if (coiContactUser) {
              vendor.coiContactUserId = null;
              vendor.emailAddress = "";
              vendor.contactName = "";
              vendor.projectUsers = vendorUsers;
            }
          } else {
            vendor.projectUsers = vendorUsers;
          }
        } else {
          vendor.projectUsers = [];
        }
      });
    } else {
      insurance.vendors.forEach((vendor) => {
        vendor.projectUsers = [];
      });
    }
    const nonCoiContactVendors = insurance.vendors.filter(
      (x) =>
        (!x.emailAddress || !x.projectUsers || !x.projectUsers.length) &&
        x.id > 0
    );
    if (nonCoiContactVendors && nonCoiContactVendors.length > 0) {
      setIsModelOpen(true);
    } else if (insurance?.requirementId && insurance.requirementId > 0) {
      setIsModelOpen(true);
    } else if (insurance?.vendors && insurance.vendors.length == 0) {
      setIsModelOpen(true);
    } else if (
      insurance?.requirementId !== null &&
      insurance.requirementId === 0
    ) {
      setInsurance({
        ...insurance,
        projectId: +globalProcoregProjectId,
      });
      insurance.projectId = +globalProcoregProjectId;
      const isRequestCreated = await onStore(insurance, "global");

      // await onLoadProject();
      setInsurance({
        ...insurance,
        vendors: defaultVendor,
        requirementId: null,
      });
      setLoadingUsers(false);
      onSaved();
      if (showCOIModal) {
        onClose(isRequestCreated);
      }
    }
  }, [
    insurance,
    setIsModelOpen,
    onLoadVendorsUsers,
    getVendorsCOItag,
    onClose,
    onSaved,
    setLoadingUsers,
    onStore,
    setInsurance,
    showCOIModal,
    defaultVendor,
    globalProcoregProjectId,
  ]);

  const paddLeft = {
    paddingLeft: "0px",
  };

  const paddRight = {
    paddingRight: "1px",
  };

  const customizeModal = {
    marginTop: "-3%",
    marginBottom: "-3%",
  };

  const customStyles = {
    group: (provided: any, state: any) => ({
      ...provided,
      paddingTop: state.data.label ? 5 : 0,
    }),
  };

  if (loading) {
    return (
      <div className="container container-wrapper p-5">
        <div className="row">
          <div className="col-md-12">
            <div className="alert alert-light text-center">
              <img src={"/images/spinner.gif"} alt="Loading" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (errorMessage) {
    return (
      <div className="container container-wrapper p-5">
        <div className="row">
          <div className="col-md-12">
            <div className="alert alert-danger text-center">
              <p>{errorMessage}</p>
            </div>
            {showCOIModal ? (
              <button
                className="btn-cutom btn btn-dark blue-btn"
                onClick={() => onClose(false)}
              >
                Cancel
              </button>
            ) : null}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div className="" style={customizeModal}>
          {!loading && !errorMessage && !isModelOpen && (
            <div className="row">
              <div className=" col-md-12">
                <Card
                  style={{
                    width: showCOIModal ? "auto" : 581,
                  }}
                >
                  <Card.Body className="p-0">
                    <div className="panel-body" style={{ padding: "1.6rem" }}>
                      <h5 className="header-details">
                        Once processed, we will send the vendor a request for a
                        COI and check the uploaded COI against the requirements.
                      </h5>
                      <Form.Group
                        controlId="companyEmail"
                        className="no-gutters"
                      >
                        <Form.Label
                          column
                          className="custom-lable"
                          style={paddLeft}
                        >
                          Select Insurance Requirements:{" "}
                          <span className="required-field">*</span>
                        </Form.Label>
                        <Col style={paddRight}>
                          <Select
                            key={insurance.requirementId}
                            className="custom-select-input"
                            classNamePrefix="name-select"
                            isMulti={false}
                            hideSelectedOptions={false}
                            onChange={handleRequirementChange}
                            getOptionLabel={(option) => `${option.description}`}
                            getOptionValue={(option) => `${option.description}`}
                            options={project?.requirements}
                            placeholder={" --Select Requirement--"}
                            noOptionsMessage={() => null}
                            // value={project?.requirementList.find(
                            //   (i) => i.id === insurance.requirementId
                            // )}
                            value={
                              insurance?.requirementId != null &&
                              insurance?.requirementId >= 0
                                ? project?.requirementList.find(
                                    (x) =>
                                      x.id === insurance.requirementId &&
                                      insurance.tabId === x.tabId
                                  )
                                : null
                            }
                            isOptionSelected={(option) => {
                              return insurance?.requirementId === option.id &&
                                insurance.tabId === option.tabId
                                ? true
                                : false;
                            }}
                            styles={customStyles}
                            components={{
                              Menu,
                            }}
                          />
                        </Col>
                      </Form.Group>
                    </div>
                  </Card.Body>
                  <Card.Footer className="cusrom-card-footer">
                    <div className="d-flex align-items-center justify-content-between clear button-group no-gutters ">
                      <div className=" text-left">
                        <p className="required-field">* required field</p>
                      </div>
                      <div className=" text-right p-2">
                        {submitting || loadingUsers ? (
                          <img src={"/images/loader.gif"} alt="Loading" />
                        ) : (
                          <>
                            {showCOIModal ? (
                              <button
                                className="btn-cutom btn btn-dark blue-btn"
                                onClick={() => {
                                  onClose(false);
                                }}
                              >
                                Cancel
                              </button>
                            ) : null}
                            <button
                              className="btn-cutom btn btn-dark blue-btn ml-2"
                              disabled={
                                !(
                                  insurance.requirementId != null &&
                                  insurance.requirementId >= 0
                                ) || submitting
                              }
                              onClick={checkCOIRoleProjectUsers}
                            >
                              {submitting ? "Submitting" : "Continue"}
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </Card.Footer>
                </Card>
              </div>
            </div>
          )}
        </div>

        {isShowModal && (
          <Modal
            show={isShowModal}
            keyboard={false}
            animation={false}
            dialogClassName="Custome-rquire"
            backdrop="static"
            centered
            onHide={() => {}}
          >
            <Modal.Body className="p-1">
              <div className="top-logo">
                <img src={procoreLogo} alt={procoreLogo} width="140" />
                <img src={COIIcon} className="mx-4" alt={COIIcon} width="60" />
                <img src={jonesLogo} alt={jonesLogo} width="75" />
              </div>

              <div className="head">Add Custom Requirements</div>

              <p className="divdesing">
                Please allow up to 24 hours for requirements to populate in
                Procore.<br></br>
                For questions, please reach out to{" "}
                <a href="mailto:integration@getjones.com">
                  {" "}
                  integration@getjones.com
                </a>
                .
              </p>
            </Modal.Body>

            <div className="got-button">
              <Button
                onClick={() => {
                  setIsShowModal1(false);

                  if (setIsShowModal) {
                    setIsShowModal(false);
                  }

                  return;
                }}
              >
                Got it
              </Button>
            </div>
          </Modal>
        )}

        {isModelOpen && (
          <MissingContactView
            insurance={insurance}
            setInsurance={setInsurance}
            isModelOpen={isModelOpen}
            showCOIModal={showCOIModal}
            permissionTemplates={permissions}
            allVendors={project.vendorList}
            submitting={submitting}
            onClose={() => {
              setIsModelOpen(false);
              setLoadingUsers(false);
            }}
            onSubmit={async (remainingVendors: any) => {
              setLoadingUsers(false);
              if (!remainingVendors) {
                showSuccessMessage("No Request Sent", <ErrorIcon />);
                setInsurance({
                  ...insurance,
                  requirementId: null,
                  vendors: defaultVendor,
                });
                if (showCOIModal) {
                  onClose(false);
                }
              } else if (remainingVendors && remainingVendors.length) {
                let data = {
                  ...insurance,
                  vendors: remainingVendors,
                };
                data.projectId = +globalProcoregProjectId;
                const isRequestCreated = await onStore(data, "global");

                // await onLoadProject();
                setInsurance({
                  ...insurance,
                  vendors: remainingVendors,
                  requirementId: null,
                });
                onSaved();
                if (showCOIModal) {
                  onClose(isRequestCreated);
                }
              }
              setIsModelOpen(false);
            }}
          />
        )}
      </>
    );
  }
}
const styles = {
  addCustomRequiremntLink: {
    display: "flex",
    color: "#F47E42",
    fontSize: "14px",
    margin: "5px 0 13px 10px",
    fontWeight: 500,
    height: "20px",
  },
};

export default CreateGlobalRequest;
